module.exports = __webpack_public_path__ + "img/degreesee-desktop.e6ebf21b.svg";